import React, { useEffect } from "react";
import {
   setTemplateName,
   setTemplateSubject,
   setTemplateSubscribers,
   setTemplateContent,
   setTemplateNewsletter,
   setNewsletterContent,
   setTemplateCoverPhotoURL
} from "appRedux/actions/Newsletter";
import { useDispatch } from "react-redux";
import NewsletterList from "../NewsletterList";
import emptyTemplate from "./Images/empty-template.png";
import "./steps.less";
import IntlMessages from "@util/IntlMessages";
import {
   setIsFileAdded,
   setTemplateIsNew,
   setTemplateSaveable
} from "../../../appRedux/actions/Newsletter";
import { Card } from "../../BP2Components";

const FirstStep = (props) => {
   const dispatch = useDispatch();
   useEffect(() => {
      dispatch(setIsFileAdded(false));
   }, []);

   const clickHandler = () => {
      dispatch(setTemplateSubject(""));
      dispatch(setTemplateName(""));
      dispatch(setTemplateCoverPhotoURL(""));
      dispatch(setTemplateContent(""));
      dispatch(setTemplateNewsletter({ name: "", id: null }));
      dispatch(setTemplateSubscribers([]));
      dispatch(setTemplateSaveable(true));
      dispatch(setTemplateIsNew(true));
      dispatch(
         setNewsletterContent({
            wId: props.id,
            subject: "",
            templateName: "",
            templateId: null,
            csv: null,
            content: "",
            newsletterName: "",
            newsletterId: null,
            subscribers: null,
            coverPhotoURL: ""
         })
      );
      props.next();
   };

   return (
      <div className="first-step-container">
         <div>
            <Card>
               <IntlMessages id="w.newsletter.choosePrepared" />{" "}
            </Card>
            <NewsletterList id={props.id} next={props.next} />
         </div>
         <div>
            <Card>
               {" "}
               <IntlMessages id="w.newsletter.createTemplate" />{" "}
            </Card>
            <div className="new-template-button" onClick={() => clickHandler()}>
               <p className="empty-template-title">
                  <IntlMessages id="w.newsletter.newTemplate" />
               </p>
               <img src={emptyTemplate} alt="empty template" className="empty-template-img"></img>
            </div>
         </div>
      </div>
   );
};

export default FirstStep;
